import styled from 'styled-components';
import { em } from 'polished';
import { appTheme } from '../../../theme';
import { mediaQuery } from '../util/style';

const FormBox = styled.div`
  background-color: ${appTheme.system.passive};
  display: flex;
  flex-direction: column;
  min-height: ${appTheme.sizing.formBoxMinHeight};
  padding: calc(${appTheme.spacing.default} * 2);
  width: ${em(appTheme.sizing.formBoxWidth)};

  ${/* sc-custom '@media'*/ mediaQuery.xsmall`
    height: 100%
    width: 100%;
  `};
`;

export default FormBox;



// WEBPACK FOOTER //
// ./src/modules/common/form/FormBox.js